import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { MdArrowBack } from 'react-icons/md'
import { Clinica } from './data'
import { styles } from './styles'

const Header = ({ voltar }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Box sx={styles.header}>
      {voltar && (
        <IconButton onClick={voltar} sx={{ color: 'white' }}>
          <MdArrowBack />
        </IconButton>
      )}
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          <Box
            sx={{
              backgroundColor: 'white',
              borderRadius: 1,
              p: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={isDesktop ? Clinica.logoHorizontalUrl : Clinica.logoUrl}
              alt={Clinica.nome}
              loading="lazy"
              decoding="async"
              style={{
                width: isDesktop ? 200 : 60,
                height: 'auto',
                objectFit: 'contain',
              }}
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
          </Box>
        </Grid>
        {!isDesktop && (
          <Grid item xs>
            <Box sx={styles.headerText}>
              <Typography variant="subtitle1" fontWeight={600}>
                {Clinica.nome}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                {Clinica.especialidade}
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

export default Header
